module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./node_modules/axios/index.js
// module id = 532
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15